import { Link } from '@tanstack/react-router'
import { ShieldAlert } from 'lucide-react'

export default function Unauthorized() {
  return (
    <div className='min-h-screen flex items-center justify-center bg-background px-4'>
      <div className='text-center max-w-md'>
        <ShieldAlert className='w-20 h-20 text-[var(--color-status-error)] mx-auto mb-6' aria-hidden='true' />
        <h1 className='text-4xl font-bold text-foreground mb-4'>
          Access Denied
        </h1>
        <p className='text-muted-foreground mb-8'>
          You don't have permission to access this page. Please contact your
          administrator if you believe this is an error.
        </p>
        <div className='flex gap-4 justify-center'>
          <Link
            to='/'
            className='px-6 py-3 bg-gradient-primary text-white rounded-lg hover:opacity-90 transition-opacity focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2'
          >
            Go Home
          </Link>
          <Link
            to='/login'
            className='px-6 py-3 border-2 border-border rounded-lg hover:bg-muted/50 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2'
          >
            Sign In
          </Link>
        </div>
      </div>
    </div>
  )
}
